import { create } from "zustand";

interface ChatState {
  error: string | null;
  setError: (error: string | null) => void;
}

export const useChatStore = create<ChatState>((set) => ({
  error: null,
  setError: (error) => set({ error }),
}));
